var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
import { MediaAsset } from 'packages/media/MediaAsset';
var embed = Quill.import('blots/embed');
var ImageAssetEmbed = /** @class */ (function (_super) {
    __extends(ImageAssetEmbed, _super);
    function ImageAssetEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageAssetEmbed.create = function (asset) {
        var node = _super.create.call(this);
        node.setAttribute('src', asset.uri);
        node.setAttribute('data-type', asset.type);
        node.setAttribute('data-id', asset.id);
        node.classList.add('w-full');
        return node;
    };
    ImageAssetEmbed.value = function (node) {
        var asset = new MediaAsset();
        asset.id = parseInt(node.getAttribute('data-id'), 10);
        asset.type = node.getAttribute('data-type');
        asset.uri = node.getAttribute('src');
        return asset;
    };
    ImageAssetEmbed.blotName = 'ImageAssetEmbed';
    ImageAssetEmbed.className = 'ql-image-asset';
    ImageAssetEmbed.tagName = 'img';
    return ImageAssetEmbed;
}(embed));
export { ImageAssetEmbed };
